/*eslint  @typescript-eslint/no-use-before-define: 0*/

import { defineModule } from "direct-vuex";
import { moduleActionContext, moduleGetterContext } from "../index";
import routerInstance from "@/plugins/router";
import GetOfficeItem from "@/models/api/offices/GetOfficeResponse";
import { getOffices } from "@/requests/offices";
import getOfficeNameFromCurrentHref from "@/utils/getParamsFromPath";

export interface OfficesStateInterface {
  allOffices: Array<GetOfficeItem>;
}

export const OfficesState: OfficesStateInterface = {
  allOffices: new Array<GetOfficeItem>(),
};

const officesModule = defineModule({
  state: OfficesState as OfficesStateInterface,
  namespaced: true as const,
  getters: {
    isOfficesDownloaded(...args): boolean {
      const { state } = _moduleGetterContext(args);
      return typeof state.allOffices !== "undefined" && state.allOffices.length > 0;
    },
  },
  mutations: {
    SET_OFFICES(state, offices: Array<GetOfficeItem>) {
      state.allOffices = offices;
    },
  },
  actions: {
    async download(context) {
      const { commit } = _moduleActionContext(context);
      const axiosResponse = await getOffices();
      if (axiosResponse.status === 200) {
        commit.SET_OFFICES(axiosResponse.data);
      }
    },
    async redirectToDefaultOfficeIfWrongOffice(context) {
      const { dispatch } = _moduleActionContext(context);
      const isProperOffice = dispatch.isProperOfficeShortName();
      if (!isProperOffice) {
        await dispatch.redirectToDefaultOffice();
      }
    },
    async redirectToDefaultOffice(context) {
      const { state } = _moduleActionContext(context);
      routerInstance
        .push({
          path: "/" + state.allOffices[0].officeShortName + "/login",
          params: {
            officeShortName: state.allOffices[0].officeShortName,
          },
        })
        .catch((t) => {
          console.log(t);
        });
    },
    isProperOfficeShortName(context): boolean {
      const { state } = _moduleActionContext(context);
      const officeShortname = getOfficeNameFromCurrentHref();
      return typeof state.allOffices.find((v) => v.officeShortName === officeShortname) === "object";
    },
  },
});

export default officesModule;

/* eslint-disable */
const _moduleGetterContext = (args: [any, any, any, any]) =>
  moduleGetterContext(args, officesModule);
const _moduleActionContext = (context: any) =>
  moduleActionContext(context, officesModule);
